const formatPrice = (price: number | undefined): number => {
  if (typeof price === 'number') return price / 100;
  return 0;
};

export default formatPrice;
